import {FC, useCallback} from 'react';

import {Button} from 'components/Button/Button';
import {Text} from 'components/Text/Text';

import styles from './CartEmpty.module.css';
import emptyImageSrc from './empty.png';

type Props = {};
export const CartEmpty: FC<Props> = () => {
    const goToHome = useCallback(() => {
        window.open('/', '_self');
    }, []);

    return (
        <div className={styles.block}>
            <img src={emptyImageSrc} className={styles.image} alt=''/>
            <Text.Bold24 className={styles.title}>
                В корзине нет товаров
            </Text.Bold24>
            <Text.Semibold16 className={styles.subtitle}>
                Найдите нужные товары в каталоге или воспользуйтесь поиском
            </Text.Semibold16>
            <Button onClick={goToHome}>На главную</Button>
        </div>
    );
};
